import { Link } from "react-router-dom";
import { Repeat, Zap, Check, ArrowRight } from "lucide-react";
import { useSettings } from "@/context/AppContext";
import { useSeo } from "@/lib/draft";
import { PageHead } from "@/pages/ComoFunciona";
import { ShareBlock } from "@/components/ShareBlock";

const Modality = ({ id, icon: I, title, text, items, highlight }) => (
  <div className={`flex flex-col rounded-3xl p-6 md:p-8 ${highlight ? "bg-[#1465C8] text-white" : "border-2 border-[#3198EF]/25 bg-white"}`} data-testid={`modality-card-${id}`}>
    <div className={`flex h-12 w-12 items-center justify-center rounded-2xl ${highlight ? "bg-white/15" : "bg-[#EDF5FF] text-[#1465C8]"}`}><I /></div>
    <h2 className="mt-5 text-2xl font-extrabold">{title}</h2>
    <p className={`mt-2 ${highlight ? "text-[#EDF5FF]" : "text-[#64748B]"}`}>{text}</p>
    <ul className="mt-5 grid gap-2 text-sm sm:grid-cols-2">
      {items.map((s) => <li key={s} className="flex gap-2"><Check size={16} className="mt-0.5 shrink-0" />{s}</li>)}
    </ul>
    <Link to={`/solicitar?tipo=pj&modalidade=${id}`} data-testid={`modality-start-${id}`}
      className={`mt-8 inline-flex min-h-[52px] items-center justify-center gap-2 rounded-xl font-bold transition-colors ${highlight ? "bg-white text-[#1465C8] hover:bg-[#EDF5FF]" : "bg-[#1465C8] text-white hover:bg-[#092C66]"}`}>
      Continuar <ArrowRight size={18} />
    </Link>
  </div>
);

export default function Empresas({ mode }) {
  const { settings } = useSettings() || {};
  const bs = settings?.business_services || { recorrente: [], pontual: [] };
  useSeo(mode === "recorrente" ? "Consultoria jurídica recorrente" : mode === "pontual" ? "Solicitação pontual para empresas" : "Para empresas",
    "Organize as necessidades jurídicas da sua empresa: consultoria recorrente ou demanda pontual, com proposta individualizada.");
  const rec = <Modality id="recorrente" icon={Repeat} highlight title="Consultoria jurídica recorrente" text="Para empresas interessadas em assessoria jurídica mensal. A proposta de honorários é elaborada individualmente." items={bs.recorrente} />;
  const pon = <Modality id="pontual" icon={Zap} title="Demanda jurídica pontual" text="Para serviços específicos da sua empresa, com análise individual da demanda." items={bs.pontual} />;
  return (
    <>
      <PageHead eyebrow="Para empresas" title="Organize as necessidades jurídicas da sua empresa." text="Sem tabelas de honorários e sem contratação automática: cada demanda recebe análise e, se cabível, proposta individualizada." />
      <section className={`wrap mt-12 grid gap-5 ${mode ? "" : "lg:grid-cols-2"}`}>
        {mode !== "pontual" && rec}
        {mode !== "recorrente" && pon}
      </section>
      <section className="wrap mt-12">
        <p className="mb-3 text-sm font-semibold text-[#64748B]">Compartilhe o atendimento empresarial</p>
        <ShareBlock path="/empresas" testid="business-share" />
      </section>
    </>
  );
}
